import { type TranslationTree } from '@/i18n/types';

export const messages = {
  hint: 'Confira a conexão e tente de novo',
  retry: 'Tentar de novo',
} satisfies TranslationTree;
